import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegsInfoTableComponent } from './legs-info-table.component';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { LocaleConverterModule, NullCheckModule, OrderModeModule, PercentPipeModule } from '@app/_shared/pipes';


@NgModule({
  declarations: [LegsInfoTableComponent],
  imports: [
    CommonModule,
    MatTableModule,
    OrderModeModule,
    NullCheckModule,
    LocaleConverterModule,
    PercentPipeModule
  ],
  exports: [
    LegsInfoTableComponent
  ]
})
export class LegsInfoTableModule { }
